// project import
import Routes from 'routes';
import ThemeCustomization from 'themes';

import { LocalizationProvider } from '@mui/x-date-pickers-pro';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import Snackbar from 'components/@extended/Snackbar';
import UpdateAvailableSnackbar from 'components/UpdateAvailableSnackbar';
import Locales from 'components/Locales';
import ScrollTop from 'components/ScrollTop';
import Notistack from 'components/third-party/Notistack';

// auth-provider
// import { JWTProvider as AuthProvider } from 'contexts/JWTContext';
import { LicenseInfo } from '@mui/x-data-grid-pro';
import { FirebaseProvider as AuthProvider } from 'contexts/FirebaseContext';
import ErrorBoundary from './ErrorBoundary';
// import { AWSCognitoProvider as AuthProvider } from 'contexts/AWSCognitoContext';
// import { Auth0Provider as AuthProvider } from 'contexts/Auth0Context';

// ==============================|| APP - THEME, ROUTER, LOCAL  ||============================== //

const App = () => {
  LicenseInfo.setLicenseKey(import.meta.env.VITE_MUI_X_LICENSE_KEY || '');

  if (!LicenseInfo) return <></>;

  return (
    <ThemeCustomization>
      <Locales>
        <ScrollTop>
          <AuthProvider>
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <>
                <Notistack>
                  <ErrorBoundary>
                    <Routes />
                    <Snackbar />
                  </ErrorBoundary>
                </Notistack>
                <UpdateAvailableSnackbar />
              </>
            </LocalizationProvider>
          </AuthProvider>
        </ScrollTop>
      </Locales>
    </ThemeCustomization>
  );
};

export default App;
